import { generateEventId } from "../google";
import { config } from "../../config";
import { post } from '../../http';
import { get } from '../../cookies';
import { logSentry } from '../../sentry';
declare const window: any;

export const sendFbEvent = (FacebookMetaData : any, currentPage: any) => {
    FacebookMetaData.event_id = generateEventId();
    dispatchFbConversionEvent(FacebookMetaData, currentPage);
};

export const dispatchFbConversionEvent = async (metaData, currentPage) => {
    if (config('isFbConversionEnabled') !== "true") return;
    metaData = getFbConversionPayload(metaData);
    metaData.user_data = await generateFbUserData(currentPage);
    const url = `${config('LAMBDA_FACEBOOK_CONVERSION_API')}`;
    try{
        const response  = await post(url, metaData);
        logFbEvent(metaData, response.data);
    } 
    catch(error){
        logFbEvent(metaData, error);
        
        logSentry({
            'page': currentPage,
            'feature': 'dispatchFbConversionEvent',
            'operation': 'dispatchFbConversionEvent',
            'errorType': 'ajaxError',
            'err': JSON.stringify(error),
            'func': 'dispatchFbConversionEvent',
            'api':`${config('LAMBDA_FACEBOOK_CONVERSION_API')}`,
            'errMsg': 'Error in dispatchFbConversionEvent function.'
        })
    }  
};

const logFbEvent = (metaData, res) => {
    if (navigator.cookieEnabled && window?.localStorage?.getItem('enableFbLogging') === 'true') {
        console.log('FB event logged:-', metaData);
        console.log('Response received:', res);
    }
};

const getFbConversionPayload = (metaData) => {
    return {
        event_id: metaData.event_id,
        event_name: metaData.event_name,
        event_time: Math.floor(new Date().getTime()/1000),
        custom_data: metaData.custom_data || {},
        event_source_url: window.location.href,
        action_source: 'website',
        site_locale: window.locale_details?.country_code || ''
    } 
};

const generateFbUserData = async (currentPage) => {
    let emailAddress : any = '';
    if (sessionStorage.getItem('np.emailAddress')) {
        emailAddress = sessionStorage.getItem('np.emailAddress');
    } else if(get("np.ct.user")) {
        try {
            const userId = get("np.ct.user");
            if (userId) {
                const response = await window.np.getEmailAddressFromUserId(userId);
                emailAddress = response.emailAddress;
                sessionStorage.setItem('np.emailAddress', emailAddress);
            }
        } catch (error) {
            logSentry({
                'page': currentPage,
                'feature': 'dispatchFbConversionEvent',
                'operation': 'generateFbUserData',
                'errorType': 'ajaxError',
                'err': JSON.stringify(error),
                'func': 'generateFbUserData',
                'api':`https://customer.api.pens.com/v1/oraclecustomernumber/?customerId=:userId`,
                'errMsg': 'Error in dispatchFbConversionEvent function.'
            })
        }
    }
    return {
        client_user_agent : navigator.userAgent,
        fbc : get('_fbc') || null,
        fbp : get('_fbp') || null,
        em: emailAddress.toUpperCase(),
    };
} 